import React from 'react';
import { setHeader } from '../../store/settings/settingsSlice';
import { useDispatch, useSelector } from 'react-redux';
import { useEffect, useState } from 'react';
import style from "./deposit.module.css";
import { useLocation, useNavigate } from 'react-router-dom';
import emptyIcon from '../../assets/images/Group 26795.svg'
import Modal from '../modal/Modal';
import arrow_right from '../../assets/images/arrow-right.svg'
import check_mark from '../../assets/images/check-mark.svg'
import profileIcon from '../../assets/images/profile.svg'
import {QRCodeSVG} from 'qrcode.react';
import spin_circle from '../../assets/images/Loader anim.png'
import cogoToast from 'cogo-toast';
import { createPaymentAddress, getPaymentAddresses } from '../../store/settings/settingsActions';


const cryptoTabs = [
  { code: "wallet-address", label: "Wallet Address" },
  { code: "internal-transfer", label: "Internal Transfer" }
];

const cryptoNames = {
  BTC: "Bitcoin",
  ETH: "Ethereum",
  CAD: "Cadano",
  LTE: "Litecoin",
  BNB: "Binance Coin"
  // Add more as needed
};

const DepositWithCryptoPage = () => {
    const dispatch = useDispatch();
     const locationHook = useLocation();
    const navigate = useNavigate();

    const {paymentAddresses,cryptocoins} = useSelector((state) => state.settings)
    const username = useSelector(state => state.auth.fullUser.username)
    const [selectedNetwork, setSelectedNetwork] = useState("");
    const [isOpen, setIsOpen] = useState(false);
    const params = new URLSearchParams(locationHook.search);
    const currency = params.get("currency") || "BTC";
    const option = params.get("option") || "wallet-address";
    let coinTypeId = params.get("id");
    const [activeTab, setActiveTab] = useState(option);
    const [isAddrGeneratedModal, setAddrGeneratedModal] = useState(false);

    // 1. Get the selected coin from cryptocoins
    const selectedCoin = (cryptocoins || []).find(
    coin => coin.currency?.toUpperCase() === currency.toUpperCase()
    );

     // If coinTypeId is not in URL, get it from selectedCoin
    if (!coinTypeId && selectedCoin) {
        coinTypeId = selectedCoin.quidaxUserId;
    }

    // 2. Build networks array from the coin's networks, comparing with paymentAddresses
    const networks = (selectedCoin?.networks || []).map(net => {
    // Find if there's a payment address for this network
    const addressObj = (paymentAddresses || []).find(
        addr => addr.network === net.id // or net.network_name if that's the field
    );
    return {
        id: net.id,
        name: net.name ? net.name.toUpperCase() : net.id.toUpperCase(),
        wallet_address: addressObj?.address || null,
        destination_tag: addressObj?.destination_tag || null,
        deposits_enabled: net.deposits_enabled,
        withdraws_enabled: net.withdraws_enabled,
    };
    });
    const selectedNetworkObj = networks.find(net => net.id === selectedNetwork);

    const cryptoName = cryptoNames[currency] || currency;

    const handleCopyToClipboard = (text, label) => {
        navigator.clipboard.writeText(text);
        cogoToast.success(`${label} copied to clipboard`, { position: 'top-right' });
    };

     const handleShareAddress = async () => {
        if (!selectedNetworkObj?.wallet_address) return;

        const shareText = `Deposit Address: ${selectedNetworkObj.wallet_address}${
            selectedNetworkObj.destination_tag ? `\nDestination Tag: ${selectedNetworkObj.destination_tag}` : ''
        }`;

        // Check if Web Share API is available
        if (navigator.share) {
            try {
                await navigator.share({
                    title: `${currency} Deposit Address`,
                    text: shareText,
                });
            } catch (err) {
                // User cancelled the share dialog, don't show error
            }
        } else {
            // Fallback: Copy to clipboard and show toast
            navigator.clipboard.writeText(shareText);
            cogoToast.success("Address copied to clipboard", { position: 'top-right' });
        }
    };

      const handleGenerateWalletAddress = async () => {
        if (!coinTypeId || !selectedNetwork || !currency) {
            // Optionally show an error/toast here
            return;
        }
        setIsOpen(true); 
        try {
            await dispatch(
            createPaymentAddress({
                coinType: currency.toLowerCase(),
                coinNetwork: selectedNetwork,
                quidaxUserId: coinTypeId,
            })
            ).unwrap();
            // Refresh addresses
            dispatch(getPaymentAddresses({ coinTypeId, currency: currency.toLowerCase() }));
            setIsOpen(false);
            setAddrGeneratedModal(true); 
        } catch (e) {
            setIsOpen(false);
        }
     };

    const handleTabChange = (tabCode) => {
        setActiveTab(tabCode);
        setSelectedNetwork(""); // Reset network selection when switching tabs
        navigate(`/deposit-with-crypto?option=${tabCode}&currency=${currency}&id=${coinTypeId}`, { replace: true });
    };


    useEffect(() => {
        dispatch(setHeader(`Receive ${currency}`));
        setActiveTab(option);
        setSelectedNetwork("");
    }, [dispatch, option, currency]);

    useEffect(() => {
        if (coinTypeId && currency) {
            dispatch(getPaymentAddresses({ coinTypeId, currency: currency.toLowerCase() }));
        }
    }, [dispatch, coinTypeId, currency]);

    return ( 
        <>

          {/* =========================== THE LOADING MODAL TO GENERATE WALLET ADDRESS  */}
      <Modal
        canClose={false}
        modalOpen={isOpen}
        setModalOpen={setIsOpen}
      >
        <div>
            <div style={{display: 'flex', justifyContent: 'center', marginTop: '25px'}}>
                <img src={spin_circle} alt="spin circle" className={style.animate_spin} />
            </div>

            <div>
                <h4 style={{color: '#40196D', fontWeight: '600', marginTop: '25px'}}>Generating Wallet</h4>
             
                <p style={{color: '#B6B6B6', maxWidth:'300px', margin: 'auto', marginTop: '15px'}}>
                  Please wait...<br/>
                    Your wallet address is being generated
                </p>
               
            </div>
        </div>

        </Modal>

        {/* ======== THE MODAL TO STATE THAT ADDRESS HAS BEEN GENERATED */}
        <Modal
        canClose={true}
        modalOpen={isAddrGeneratedModal}
        setModalOpen={setAddrGeneratedModal}
      >
        <div>
            <div style={{display: 'flex', justifyContent: 'center', marginTop: '25px'}}>
                <img src={check_mark} alt="check mark" />
            </div>

            <div>
                <h4 style={{color: '#40196D', fontWeight: '600', marginTop: '25px'}}>Wallet Address Generated</h4>
            
                <p style={{color: '#B6B6B6', maxWidth:'300px', margin: 'auto', marginTop: '15px'}}>
                  Your wallet deposit address has been generated successfully
                </p>
            </div>

            <button onClick={() => setAddrGeneratedModal(false)} style={{marginTop: '20px'}} className={style.save}>
               Continue
            </button>

        </div>

        </Modal>

          <div className={style.depositCryptoPage}>
        <div className={style.depositCryptoTabs}>
            {cryptoTabs.map(tab => (
            <button
                key={tab.code}
                className={`${style.depositCryptoTab} ${activeTab === tab.code ? style.activeTab : ""}`}
                onClick={() => handleTabChange(tab.code)}
            >
                {tab.label}
            </button>
            ))}
        </div>
          <hr className={style.depositCryptoDivider} />
                 {activeTab === "wallet-address" && (
                <>
                    <div className={style.depositCryptoLabel}>Select Network</div>
                    <select
                    className={style.depositCryptoSelect}
                    value={selectedNetwork}
                    onChange={e => setSelectedNetwork(e.target.value)}
                    >
                    <option value="">Select Network</option>
                     {networks.map(net => (
                            <option value={net.id} key={net.id}>
                            {net.name}
                            </option>
                        ))}
                    </select>

                    {selectedNetwork && selectedNetworkObj?.wallet_address ? (
                    <>
                      <div style={{maxWidth: '500px', paddingBottom: '20px'}}>
                        <div className={style.depositNetworkNote}>
                        Only send {cryptoName} to the address. Ensure the sender is on the {selectedNetworkObj.name} network otherwise you might lose your deposit. Also, do not send less than 0.001{cryptoName} to this address or deposits will be lost
                        </div>
                        <div className={style.depositDetailsTitle}>Deposit Details</div>
                        <div className={style.depositQrWrap}>
                        <QRCodeSVG value={selectedNetworkObj.wallet_address} size={160} />
                        </div>
                        <div className={style.depositAddressBox}>
                        <div className={style.depositAddressLabel}>Deposit Address</div>
                        <div className={style.depositAddressValue}>
                            {selectedNetworkObj.wallet_address}
                            <button
                            className={style.depositCopyBtn}
                            onClick={() => handleCopyToClipboard(selectedNetworkObj.wallet_address, 'Deposit Address')}
                            >
                            <svg width="20" height="20" fill="none" viewBox="0 0 24 24">
                                <rect x="7" y="7" width="10" height="10" rx="2" stroke="#40196D" strokeWidth="1.5"/>
                                <rect x="3" y="3" width="10" height="10" rx="2" stroke="#40196D" strokeWidth="1.5" opacity="0.4"/>
                            </svg>
                            </button>
                        </div>
                        </div>
                        {selectedNetworkObj.destination_tag && (
                        <div className={style.depositAddressBox} style={{marginTop: '20px'}}>
                         <div className={style.depositAddressLabel}>
                            Destination Tag 
                            <span style={{
                                marginLeft: '8px',
                                color: '#FF6B6B',
                                fontSize: '12px',
                                fontWeight: '700',
                                textTransform: 'uppercase'
                            }}>
                                (Required)
                            </span>
                        </div>
                        <div className={style.depositAddressValue}>
                            {selectedNetworkObj.destination_tag}
                            <button
                            className={style.depositCopyBtn}
                            onClick={() => handleCopyToClipboard(selectedNetworkObj.destination_tag, 'Destination Tag')}
                            >
                            <svg width="20" height="20" fill="none" viewBox="0 0 24 24">
                                <rect x="7" y="7" width="10" height="10" rx="2" stroke="#40196D" strokeWidth="1.5"/>
                                <rect x="3" y="3" width="10" height="10" rx="2" stroke="#40196D" strokeWidth="1.5" opacity="0.4"/>
                            </svg>
                            </button>
                        </div>
                        </div>
                        )}
                        
                        <button className={style.depositShareBtn} onClick={handleShareAddress}>Share Address</button>
                        </div>
                    </>
                    ) : (
                  <>
                   {(!selectedNetwork || !selectedNetworkObj?.wallet_address) && (
                        <div className={style.depositCryptoEmpty}>
                            <img src={emptyIcon} alt="No Address" className={style.depositCryptoEmptyImg} />
                            <div className={style.depositCryptoEmptyText}>
                            {!selectedNetwork
                                ? "No Address Found"
                                : `No Address Found For ${selectedNetworkObj?.name || selectedNetwork}`}
                            </div>
                            <div className={style.depositCryptoEmptySub}>
                            {!selectedNetwork
                                ? "Please Select a Network"
                                : "Please Generate Wallet Address"}
                            </div>
                            {selectedNetwork && !selectedNetworkObj?.wallet_address && (
                            <button
                                className={style.depositGenerateBtn}
                                onClick={handleGenerateWalletAddress}
                            >
                                Generate Wallet Address
                            </button>
                            )}
                        </div>
                        )}
                    </>
                    )
                    }
                </>
                )}
        {activeTab === "internal-transfer" && (
           <>
           <div className={style.internalTransferSubtitle}>
            Copy and share your username or email address below with other Astro users to receive funds into your {cryptoName} wallet.
            </div>

            <div className={style.cyptoBankDiv}>
                <div style={{display: 'flex', alignItems: 'center', gap: '10px'}}>
                    <div className={style.cyptoBankIconWrap}>
                            <img src={profileIcon} alt='profile icon' />                                
                    </div>
                    <div>
                    <h6 className={style.title}>Username</h6>
                    <p className={style.subtitle}>{username || ''}</p>
                  </div>
                </div>
                <div className={style.ctaDiv}>
                    <button  className={style.ctaBtn}>Copy to Deposit</button>
                    <img src={arrow_right} alt='arrow right' />
                </div>
            </div>
            </>
        )}
        </div>
        </>
     );
}
 
export default DepositWithCryptoPage;